import React, { useCallback } from 'react';
import { Box } from '@mui/material';
import { colors, Typography } from '@sweep-io/sweep-design';
import { TableIllustration } from './ArtifactIllustrations';
import { useTableArtifactsOptional } from './useTableArtifacts';

interface TableArtifactPreviewProps {
  tableId: string;
}

export const TableArtifactPreview: React.FC<TableArtifactPreviewProps> = ({ tableId }) => {
  const tableArtifactContext = useTableArtifactsOptional();
  const isLoading = tableArtifactContext?.isLoading ?? false;

  const handleViewDetails = useCallback(() => {
    if (tableArtifactContext) {
      tableArtifactContext.openTablePanel(tableId);
    }
  }, [tableArtifactContext, tableId]);

  return (
    <Box
      sx={{
        border: `1px solid ${colors.grey[300]}`,
        borderRadius: '12px',
        padding: 2,
        backgroundColor: 'white',
        width: '100%',
        height: '78px',
        transition: 'all 0.2s ease-in-out',
        cursor: !tableArtifactContext ? 'default' : isLoading ? 'wait' : 'pointer',
        position: 'relative',
        overflow: 'hidden',
        '&:hover': {
          borderColor: colors.blue[500],
        },
      }}
      onClick={handleViewDetails}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
        <Typography variant="body">Table Data</Typography>
        <Typography variant="caption" color={colors.grey[700]}>
          Data table
        </Typography>
      </Box>
      <Box
        sx={{
          position: 'absolute',
          right: '20px',
          bottom: '-7px',
        }}
      >
        <TableIllustration />
      </Box>
    </Box>
  );
};
